export function removeEmptyObjects(obj) {
  if (Array.isArray(obj)) {
    return obj
      .map(value =>
        value && typeof value === 'object' ? removeEmptyObjects(value) : value,
      )
      .filter(value => {
        if (value === '' || value === undefined || value === null) {
          return false
        }

        if (
          value &&
          typeof value === 'object' &&
          !Array.isArray(value) &&
          Object.keys(value).length === 0
        ) {
          return false
        }

        return true
      })
  }

  let finalObj = {}
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') {
      const nestedObj = removeEmptyObjects(obj[key])
      if (Object.keys(nestedObj).length) {
        finalObj[key] = nestedObj
      }
    } else if (obj[key] !== '' && obj[key] !== undefined && obj[key] !== null) {
      finalObj[key] = obj[key]
    }
  })
  return finalObj
}
